import React, { useEffect } from 'react'
import UserLayout from '../components/custom/layouts/UserLayout'
import { useDispatch, useSelector } from 'react-redux';
import { RootState, StoreState } from '../redux/store';
import { apiUrl } from "../config";
import { BsTelephone } from "react-icons/bs";
import { LocalFormatDate } from '../config/functions';
import { fetchPurchaseAction, PurchaseType } from '../redux/actions/purchaseActions';
import { fetchPurchaseReturnAction, PurchaseReturnType } from '../redux/actions/purchaseReturnAction';
import { fetchSalesAction, SalesItems, SalesType } from '../redux/actions/salesActions';
import { fetchSalesItemAction } from '../redux/actions/salesItemAction';
import { fetchSalesReturnAction, SalesReturnType } from '../redux/actions/salesReturnAction';



const Dashboard = () => {
  const dispatch = useDispatch();
  const clientsData = useSelector(
    (state: RootState) => state.clientRegistration
  );
  const clients = clientsData.slice(0, 1).map((item) => item);
  const purchaseList = useSelector<StoreState, PurchaseType[]>((state) => state.purchase);
  const purchaseReturnList = useSelector<StoreState, PurchaseReturnType[]>(state => state.purchaseReturn);
  const salesList = useSelector<StoreState, SalesType[]>((state) => state.sales);
  const salesReturnList = useSelector<StoreState, SalesReturnType[]>(state => state.salesReturn)       
  const purchaseTotalQuantity = purchaseList?.reduce((totalQty, purchase) => {
    const innerTotal = purchase?.purchaseItems?.reduce(
      (sum, item) => sum + (Number(item?.quantity) || 0), 0 ) || 0;
      return totalQty + innerTotal;
  }, 0);

  const purchaseGrandTotal = purchaseList?.reduce((total, purchase) => total + (Number(purchase.grandTotal) || 0), 0);
  const purchaseReturnTotalQuantity = purchaseReturnList?.reduce((totalQty, purchase) => {
    return (
      totalQty +
      purchase.purchaseReturnItems?.reduce(
        (sum, item) => sum + (Number(item.quantity) || 0),
        0
      )
    );
  }, 0);
  const purchaseReturnGrandTotal = purchaseReturnList?.reduce(
    (total, purchase) => total + (Number(purchase.grandTotal) || 0),0);
  
  const salesGrandTotal = salesList?.reduce(
    (total, sales) => total + (Number(sales.grandTotal) || 0),
    0
  );
  const salesTotalQuantity = salesList?.reduce(
    (totalQty, sale) => {
      return (
        totalQty +
        sale.salesItems?.reduce(
          (sum, item) => sum + (Number(item.quantity) || 0),
          0
        )
      );
    },
    0
  );

  const salesReturnGrandTotal = salesReturnList?.reduce(
    (total, sales) => total + (Number(sales.grandTotal) || 0),
    0
  );
  const salesReturnTotalQuantity = salesReturnList?.reduce((totalQty, sale) => {
    return (
      totalQty +
      sale.salesReturnItems?.reduce(
        (sum, item) => sum + (Number(item.quantity) || 0),
        0
      )
    );
  }, 0);

  const currentYear = new Date().getFullYear();
  const financialYearStart = new Date(currentYear, 3, 1);
  const finacialYearEnd = new Date(currentYear+1,2,31);
  const finacialYearRange = `${LocalFormatDate(
    financialYearStart.toDateString()
  )} to ${LocalFormatDate(finacialYearEnd.toDateString())}`;

  useEffect(() => {
    dispatch(fetchPurchaseAction());
    dispatch(fetchPurchaseReturnAction());
    dispatch(fetchSalesAction());
    // dispatch(fetchSalesItemAction());
    dispatch(fetchSalesReturnAction());
  }, [])

  useEffect(() => {
    console.log("from UseEffect salesList",salesList);
    
  },[salesList])

  return (
    <>
      <UserLayout>
        {clients.map((client) => (
          <>
            <div className="row">
              <div className="col-4"></div>
              <div className="col-4"></div>
              <div className="col-4">
                <p className="fs-5 fw-semibold me-5 d-inline-block text-end mb-0">
                  GST NO : {client.gstNo}
                </p>
                <p className="fs-5 fw-semibold text-end text-primary mb-0 d-inline-block ms-5 me-4">
                  <BsTelephone size={16} color="#0d6efd" /> +91{" "}
                  {client.contactNo1}
                </p>
              </div>
            </div>
            <div className="row align-items-center justify-content-around my-0 mx-auto p-0">
              <div className="col-8 m-0">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h2 className="fw-semibold d-flex gap-3">
                      <div>
                        <img
                          src={`${apiUrl}/${client.shopLogo}`}
                          alt="logo"
                          style={{ height: "75px", width: "75px" }}
                        />
                      </div>
                      <div>
                        {client.shopFullName}
                        <p className="fst-italic fs-4 py-2">{client.tagLine}</p>
                      </div>
                    </h2>
                  </div>
                  <div className="col-4 fs-5 fw-semibold m-0"></div>
                </div>
              </div>
              <div className="col-1 m-0"></div>
              <div className="col-3">
                <p className="mb-0 fs-5 text-end fw-semibold">
                  {client.address1}, {client.address2},
                </p>
                <p className="mb-0 fs-5 text-end fw-semibold">
                  {client.place}, {client.taluk},
                </p>
                <p className="mb-0 fs-5 text-end fw-semibold">
                  {client.district} - {client.pincode}.
                </p>
              </div>
            </div>
            <div className="row my-0 mx-auto">
              <div className="col-8">
                <div
                  id="carouselExampleIndicators"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <img
                        src={`${apiUrl}/${client.bannerImage}`}
                        // className="w-100 h-1"
                        style={{
                          width: "100%",
                          height: "61vh",
                          objectFit: "fill",
                        }}
                        alt="super-market"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-4 bg-secondary">
                <div className="text-center mb-2">
                  <p className="fs-3 fw-bold text-light bg-blue mt-2">
                    {finacialYearRange}
                  </p>
                </div>
                <div className="card shadow lg p-2 my-0 mx-auto">
                  <table className="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th scope="col" className="text-center"></th>
                        <th scope="col" className="text-center">
                          Qty
                        </th>
                        <th scope="col" className="text-center">
                          Grand Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="fw-bold">OpeningStock(+)</td>
                        <td className="text-end fw-bold">0</td>
                        <td className="text-end fw-bold">0</td>
                      </tr>
                      <tr>
                        <td className="fw-bold">Purchase(+)</td>
                        <td className="text-end fw-bold">
                          {purchaseTotalQuantity}
                        </td>
                        <td className="text-end fw-bold">
                          {purchaseGrandTotal}
                        </td>
                      </tr>
                      <tr>
                        <td className="fw-bold">PurchaseReturn(-)</td>
                        <td className="text-end fw-bold">
                          {purchaseReturnTotalQuantity}
                        </td>
                        <td className="text-end fw-bold">
                          {purchaseReturnGrandTotal}
                        </td>
                      </tr>
                      <tr>
                        <td className="fw-bold">Sales(-)</td>
                        <td className="text-end fw-bold">
                          {salesTotalQuantity}
                        </td>
                        <td className="text-end fw-bold">{salesGrandTotal}</td>
                      </tr>
                      <tr>
                        <td className="fw-bold">SalesReturn(+)</td>
                        <td className="text-end fw-bold">
                          {salesReturnTotalQuantity}
                        </td>
                        <td className="text-end fw-bold">
                          {salesReturnGrandTotal}
                        </td>
                      </tr>
                      <tr>
                        <td className="fw-bold">Delivery Note(+)</td>
                        <td className="text-end fw-bold">0</td>
                        <td className="text-end fw-bold">0</td>
                      </tr>
                      <tr>
                        <td className="fw-bold">Delivery Return(+)</td>
                        <td className="text-end fw-bold">0</td>
                        <td className="text-end fw-bold">0</td>
                      </tr>
                      <tr>
                        <td className="fw-bold">Damages(-)</td>
                        <td className="text-end fw-bold">0</td>
                        <td className="text-end fw-bold">0</td>
                      </tr>
                      <tr>
                        <td className="fw-bold text-dark ">
                          Current Stock
                        </td>
                        <td className="text-end fw-bold text-dark">
                          {(purchaseTotalQuantity +
                            salesReturnTotalQuantity) -
                            (purchaseReturnTotalQuantity + salesTotalQuantity)}
                        </td>
                        <td>{}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        ))}
      </UserLayout>
    </>
  );
}

export default Dashboard